<textarea #editor></textarea>